import { ThemeProvider, CssBaseline, StyledEngineProvider } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Provider as RollbarProvider } from "@rollbar/react";
import { billingTheme } from "@theme/billingTheme";
import { UserContextProvider } from "@context/UserContext";
import { AuthContextProvider } from "@context/AuthContext";
import { AuthInterceptorProvider } from "@context/AuthInterceptorProvider";
import { AccessGuard } from "@context/AccessGuard";
import { SubscriptionContextProvider } from "@context/SubscriptionContext";
import { TransactionContextProvider } from "@context/TransactionContext";
import { PaymentMethodContextProvider } from "@context/PaymentMethodContext";
import { NotificationContextProvider } from "@context/NotificationContext";
import AppErrorBoundary from "@components/Common/AppErrorBoundary";
import AppLayout from "@components/Layout/AppLayout";
import parseDayJsLocaleFromLanguageCode from "@utils/parseDayJsLocaleFromLanguageCode";
import rollbar from "@utils/rollbar";

const App = () => {
  const dayjsLocale = parseDayJsLocaleFromLanguageCode(navigator.language);

  return (
    <RollbarProvider instance={rollbar}>
      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={billingTheme}>
          <CssBaseline />
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={dayjsLocale}>
            <AppErrorBoundary>
              <AuthContextProvider>
                <AuthInterceptorProvider>
                  <AccessGuard>
                    <UserContextProvider>
                      <SubscriptionContextProvider>
                        <TransactionContextProvider>
                          <PaymentMethodContextProvider>
                            <NotificationContextProvider>
                              <AppLayout />
                            </NotificationContextProvider>
                          </PaymentMethodContextProvider>
                        </TransactionContextProvider>
                      </SubscriptionContextProvider>
                    </UserContextProvider>
                  </AccessGuard>
                </AuthInterceptorProvider>
              </AuthContextProvider>
            </AppErrorBoundary>
          </LocalizationProvider>
        </ThemeProvider>
      </StyledEngineProvider>
    </RollbarProvider>
  );
};

export default App;
